import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import { useToast } from "../../../contexts/ToastContext";

import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

export function ProductCategoryDetailsViewModel(logout, categoryId) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState({ type: {} });

  const [breadCrumbs, setBreadCrumbs] = useState([
    {
      name: "Primary Categories",
      href: "/primary-categories",
      current: false,
    },
    { name: "Create New", href: "#", current: true },
  ]);


  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getCategory = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(
      `products/categories/${categoryId}`,
      payload
    );
    if (callResult.success) {
      setCategory(callResult.data);
      setBreadCrumbs([
        {
          name: "Primary Categories",
          href: "/primary-categories",
          current: false,
        },
        { name: callResult.data.name, href: "#", current: true },
      ]);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch category");
    }
    setLoading(false);
  };

  const createCategory = async function (values) {
    let callResult = await makePostApiCall(
      `products/categories/create`,
      values,
      "multipart/form-data"
    );

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
      window.location = "/primary-categories/" + callResult.data.id;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not create category");
    }
  };

  const updateCategory = async function (values) {
    let callResult = await makePostApiCall(
      `updatePrimaryCategory/${categoryId}`,
      values,
      "multipart/form-data"
    );

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not update category");
    }
  };

  return {
    createCategory,
    updateCategory,
    getCategory,
    category,
    loading,
    emptyModal,
    breadCrumbs,
  };
}
